export default "__VITE_ASSET__DejUqFbO__"